import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* REMOVE-FOR-CLIENT-SSR-START */
export const controllers = [{value: () => import(/* webpackPreload: true */ "./@module/controller.js"), path: "./@module/controller.js"}];
export const models = [];
/* REMOVE-FOR-CLIENT-SSR-END */
export const libs = [{value: () => import(/* webpackPreload: true */ "./@libs/Account.js"), path: "./@libs/Account.js"}];
export const styles = [];
export const constants = [];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [{value: () => import(/* webpackPreload: true */ "./@stores/CreateUserModal.store.js"), path: "./@stores/CreateUserModal.store.js"}, {value: () => import(/* webpackPreload: true */ "./@stores/UpdateUserModal.store.js"), path: "./@stores/UpdateUserModal.store.js"}, {value: () => import(/* webpackPreload: true */ "./@stores/UsersTable.store.js"), path: "./@stores/UsersTable.store.js"}];
export const extensions = [];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* webpack-strip-block:removed */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
